import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BackgroundWrapper = ({ children }) => {
    const location = useLocation();
    const [isNavbarHidden, setIsNavbarHidden] = useState(false);

    useEffect(() => {
        // Hide navbar for specific paths
        if (location.pathname === '/sceau') {
            setIsNavbarHidden(true);
        } else {
            setIsNavbarHidden(false);
        }
    }, [location]);

    // Papier des blocs parchemin : décalage et retournement au hasard (cf. .fondParchemin dans App.css)
    useEffect(() => {
        document.querySelectorAll('.fondParchemin:not([data-papier])').forEach((bloc) => {
            const sens = () => (Math.random() < 0.5 ? -1 : 1);
            bloc.dataset.papier = '';
            bloc.style.setProperty('--papier-pos', `${Math.floor(Math.random() * 1400)}px ${Math.floor(Math.random() * 1000)}px`);
            bloc.style.setProperty('--papier-sens', `${sens()} ${sens()}`);
        });
    }, [location.pathname]);

    const getBackgroundImage = () => {
        switch (location.pathname) {
            case '/':
                return '/img/fond_hero.webp';
            case '/Validation':
            case '/AideDeJeu':
            case '/Univers':
            case '/Bonus':
            case '/Mentionslegales':
            case '/validation':
            case '/aideDeJeu':
            case '/univers':
            case '/bonus':
            case '/mentionslegales':
                return '/img/fond-hero-aide-de-jeu.webp';
            case '/sceau':
            case '/Fin':
            case '/Fin2':
            case 'NotFound':
            default:
                return '';
        }
    };

    const getBackgroundColor = () => {
        switch (location.pathname) {
            case '/Fin':
            case '/fin':
                return 'black';
            case '/Fin2':
            case '/fin2':
                return '#16172d';
            default:
                return 'transparent'; // Default to transparent for other pages
        }
    };

    const backgroundImage = getBackgroundImage();
    const backgroundColor = getBackgroundColor();

    return (
        <div className={`app page_${location.pathname.replace(/^\/+/, '')}`} style={{ backgroundImage: `url(${backgroundImage})`, backgroundColor: backgroundColor }}>
            {!isNavbarHidden && children[0]} {/* Render Navbar if not hidden */}
            {children[1]}
        </div>
    );
};

export default BackgroundWrapper;
